import { Constant } from '../constants/constant';
import {
  RvsfUserResponse,
  RvsfUserFormValue,
  RvsfUserRequest,
} from '../models/rvsf-user.model';

export class RvsfUserMapper {
  // ================= API → FORM =================
  static toForm(apiData: RvsfUserResponse['data']): RvsfUserFormValue {
    return {
      fullName: apiData?.full_name ?? '',
      email: apiData?.email ?? '',
      password: '',
      designation: apiData?.designation ?? '',
      mobileNumber: apiData?.mobile_number ?? '',
      rvsfId: apiData?.rvsf_id ?? null,
      rvsfName: apiData?.rvsf_name ?? '',
      roleId: apiData?.role_id ?? null,
      roleName: apiData?.role_name ?? '',
      isAdministrator: !!apiData?.is_administrator,
      branchIds: apiData?.branches?.map((b) => b.branch_id) ?? [],
      profilePictureUrl: apiData?.profile_picture_path ?? null,
    };
  }

  // ================= FORM → API =================
  static toRequest(form: RvsfUserFormValue): RvsfUserRequest {
    return {
      full_name: form.fullName.trim(),
      email: form.email.trim(),
      password: form.password,
      designation: form.designation.trim(),
      mobile_number: form.mobileNumber.trim(),
      role_id: Number(form.roleId),
      is_administrator: form.isAdministrator,
      branch_ids: form.branchIds ?? [],
      rvsf_id: Number(form.rvsfId),
    };
  }
}
